import React, { useState } from 'react';

function SaveSearchModal({ isOpen, onClose, onSaved, currentFilters, userId }) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!name.trim()) {
      setError('Please enter a name for your search');
      return;
    }

    setSaving(true);
    setError('');

    const payload = {
      userId,
      name,
      zip: currentFilters.zip || null,
      makeName: currentFilters.makeName || null, // ✅ Corrected here
      model: currentFilters.model || null,
      minYear: currentFilters.minYear || null,
      maxYear: currentFilters.maxYear || null,
      minPrice: currentFilters.minPrice || null,
      maxPrice: currentFilters.maxPrice || null,
      maxDistance: currentFilters.maxDistance || null,
      sort: currentFilters.sort || null
    };

    console.log(payload);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/savedsearches`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error('Failed to save search');

      onSaved?.();  // optional callback
      onClose();    // close modal
    } catch (err) {
      setError('Error saving search.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%',
      height: '100%', backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
    }}>
      <div style={{
        backgroundColor: '#fff', padding: '2rem', borderRadius: '8px',
        width: '90%', maxWidth: '400px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
      }}>
        <h3>Save This Search</h3>
        <input
          type="text"
          placeholder="Search name"
          value={name}
          onChange={e => setName(e.target.value)}
          style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
        />
        {error && <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
          <button onClick={onClose} disabled={saving}>Cancel</button>
          <button onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SaveSearchModal;
